import { render, staticRenderFns } from "./ObtainedSpecialityMultiplePickerInput.vue?vue&type=template&id=57ae80f8&scoped=true&"
import script from "./ObtainedSpecialityMultiplePickerInput.vue?vue&type=script&lang=js&"
export * from "./ObtainedSpecialityMultiplePickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ae80f8",
  null
  
)

export default component.exports